import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'province'
})
export class ProvincePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let provinces = {
      'BC': "British Columbia",
      'AB': "Alberta",
      'SK': "Saskatchewan",
      'MB': "Manitoba",
      'ON': "Ontario",
      'QC': "Quebec",
      'NB': "New Brunswick",
      'NS': "Nova Scotia",
      'PE': "Prince Edward Island",
      'NL': "Newfoundland",
      'YT': "Yukon",
      'NT': "Northwest Territories",
      'NU': "Nunavut"
    };

    return provinces[value];
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/province.pipe.ts